// extracted by mini-css-extract-plugin
export default {"container":"AccordionSideNav_container__pXLwU"};